import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading, isAdmin } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center text-zinc-500 text-sm">
        <Loader2 className="w-4 h-4 animate-spin mr-2" /> Memuat sesi...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (requireAdmin && !isAdmin) {
    return (
      <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center gap-3 p-8">
        <div className="text-6xl">🔒</div>
        <div className="font-display text-xl text-zinc-100">Akses ditolak</div>
        <div className="text-sm text-zinc-500">Halaman ini hanya untuk admin/radiolog.</div>
      </div>
    );
  }

  return children;
}
